<script setup lang="ts">
import Engagement from './icons/Engagement.vue';
import { useAnalyticsService } from '@/lib/util/analytics/useAnalyticsService';
import { useKioskConfigStore } from '@/stores/kioskConfig';
import { getKioskInstallationId, INSTALLATION_ID_KEY } from '@/lib/util/auth';
import KioskConnectionMode from '@/lib/request/types/KioskConnectionMode';

const URL_FEEDBACK_FORM = 'https://deputy.typeform.com/to/o9mqL238';
const URL_OLD_KIOSK = '/kiosk';

const urlParam =
  useKioskConfigStore().data.KioskConnectionMode === KioskConnectionMode.URL
    ? `?${INSTALLATION_ID_KEY}=${getKioskInstallationId()}`
    : '';

const urlSwitchBack = `${URL_OLD_KIOSK}${urlParam}`;
const analytics = useAnalyticsService();

function trackSwitchBack() {
  analytics.track(
    {
      name: 'VIEW_OPENED',
      screen: 'HOME',
    },
    {
      source: 'Web Time Clock beta banner - Switch back',
      view: {
        details: {
          name: 'Legacy Web Kiosk',
          type: 'SCREEN',
        },
      },
    }
  );
}
</script>

<template>
  <div class="banner-old-kiosk">
    <Engagement />
    <div class="__text">
      <span
        ><a
          :href="URL_FEEDBACK_FORM"
          target="_blank"
          data-test-id="share-thoughts"
          >Share your thoughts</a
        >
        about this Time Clock
      </span>
      <a
        @click="trackSwitchBack"
        :href="urlSwitchBack"
        data-test-id="switch-back"
        >Switch Back</a
      >
    </div>
  </div>
</template>

<style scoped>
.banner-old-kiosk {
  background-color: #f3f3f7;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  gap: 15px;
}

.__text {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
}

a {
  color: var(--co-accent-primary);
}
</style>
